export default {
  tabs: {
    profile: 'Profiel',
    branding: 'Branding',
    domain: 'Domein',
    earning: 'Verdiensten',
    feature_flags: 'Functiemarkeringen',
    notification_channels: 'Meldingskanalen',
    pricing: 'Prijzen',
    fees: 'Tarieven',
    payments: 'Betalingen',
    billing: 'Facturatie',
  },
  earning: {
    internal_notice: 'Alleen FoodAmigos-instellingen. Niet zichtbaar voor de partner.',
    read_only_notice: 'Alleen-lezen. Klik op Bewerken om een waarde te wijzigen.',
    editing_notice: 'Bewerken — wijzigingen beïnvloeden echte uitbetalingsberekeningen.',
  },
  fees: {
    internal_notice:
      'Alleen instellingen van FoodAmigos. Niet zichtbaar voor de partner, en alleen super admins kunnen dit tabblad openen. Wijzigingen beïnvloeden wat gasten betalen en wat het platform verdient.',
    read_only_notice: 'Alleen-lezen. Klik op Bewerken om een waarde op dit tabblad te wijzigen.',
    editing_notice:
      'Bewerken — Opslaan schrijft zowel de servicekosten als de verwerkingstarieven. Tarieven gelden vanaf de volgende afschrijving; eerdere transacties behouden de marge die daarvoor is vastgelegd.',
  },
  profile: {
    read_only_notice: 'Alleen-lezen. Klik op Bewerken om een waarde te wijzigen.',
    editing_notice: 'Bewerken — de weergavenaam is zichtbaar voor consumenten.',
    form: {
      name: {
        label: 'Partnernaam',
        hint: 'De juridische naam / entiteitsnaam. Intern gebruikt en op facturen.',
      },
      display_name: {
        label: 'Weergavenaam voor consumenten',
        hint: 'Het label „Mogelijk gemaakt door ___" dat klanten zien. Standaard de partnernaam als leeg gelaten.',
      },
      admin_email: {
        label: 'Beheerders-e-mail',
        hint: 'Het uitgenodigde beheerdersaccount. Kan hier niet worden gewijzigd — neem contact op met engineering om het account te verplaatsen.',
      },
      invoicing_emails: {
        label: 'E-mails voor facturen',
        hint: 'Ontvangstbewijzen voor facturen die aan deze partner worden gefactureerd, worden naar elk van deze adressen gestuurd. Laat leeg om het e-mailadres van de beheerder te gebruiken.',
        placeholder: 'Beheerders-e-mail',
      },
      status: {
        label: 'Status',
        hint: 'Uitgenodigde partners worden actief bij eerste aanmelding — handmatig activeren slaat dat over. Opschorten deactiveert alle teamaanmeldingen van de partner.',
      },
      region: {
        label: 'Regio',
        hint: 'Het land staat vast. Kies een staat als de restaurants van de partner belastingregels op staatsniveau volgen — dit wijzigt alleen de standaardinstellingen van de partner, niet bestaande restaurants.',
      },
      messenger_audience: {
        label: 'Support chat',
        hint: 'Wie onder deze partner krijgt de FoodAmigos-supportchat. FoodAmigos-medewerkers hebben dit altijd. White-label partners ondersteunen hun eigen restaurants, dus alleen hun beheerders krijgen dit.',
        options: {
          everyone: 'Iedereen, restaurants inbegrepen',
          partner_admins: 'Alleen partnerbeheerders',
          nobody: 'Niemand',
        },
      },
      shop_domains: {
        label: 'Shopdomeinen',
        hint: 'Hoofddomeinen waarop de restaurantshops van de partner worden gehost. Het primaire domein wordt gebruikt voor nieuwe merken. De partner koppelt en ontkoppelt zijn eigen winkeldomeinen zelf; het tabblad Domein toont hun DNS-records.',
      },
    },
    region: {
      whole_country: 'Heel land',
    },
    shop_domains: {
      primary: 'Primair',
      platform_default: 'Platformstandaard',
      empty: 'Nog geen shopdomein gekoppeld',
    },
    statuses: {
      invited: 'Uitgenodigd',
      active: 'Actief',
      suspended: 'Opgeschort',
    },
    custody: {
      label: 'Betalingsverwerking',
      not_configured: 'Nog niet geconfigureerd',
      provider: 'Eigen gateway van de partner',
      platform: 'FoodAmigos verwerkt betalingen',
      bank_account: {
        set: 'Bankrekening: {{label}} ({{status}})',
        missing: 'Nog geen bankrekening. De partner voert deze in bij Partnerfacturatie.',
        statuses: {
          active: 'actief',
          pending_verification: 'wordt geverifieerd',
          action_needed: 'actie vereist',
          errored: 'uitbetaling mislukt',
          missing: 'ontbreekt',
        },
      },
      hint: 'Bepaald door de betalingsconfiguratie op het tabblad Betalingen en vergrendeld zodra een rail is opgeslagen. Bij verwerking via FoodAmigos wordt het omzetaandeel van de partner maandelijks uitbetaald.',
      kyc: {
        label: 'Uitbetalingsaccount',
        missing: 'Nog niet aangemaakt',
        incomplete: 'Verificatie niet voltooid',
        complete: 'Klaar voor uitbetalingen',
        currently_due: 'Stripe heeft nog nodig: {{fields}}',
        send_link: 'Onboardinglink verzenden',
        link_copied:
          'Onboardinglink gekopieerd naar het klembord — stuur deze door naar de partner. De link is eenmalig bruikbaar en verloopt.',
        link_ready: 'Onboardinglink — stuur deze door naar de partner (eenmalig, verloopt)',
        link_failed: 'Kan de onboardinglink niet aanmaken.',
      },
    },
    suspend_confirm: {
      title: 'Deze partner opschorten?',
      description:
        'Alle teamleden van de partner worden gedeactiveerd en hun sessies ingetrokken. Hun restaurants blijven actief.',
    },
  },
  branding: {
    read_only_notice: 'Alleen-lezen. Klik op Bewerken om een waarde te wijzigen.',
    editing_notice: 'Bewerken — wijzigingen zijn zichtbaar op de white-label omgevingen van de partner.',
    upload: 'Logo uploaden',
    logo: {
      label: 'Logo',
      hint: 'Getoond op de white-label omgevingen van de partner.',
    },
    circle_logo: {
      label: 'Favicon / rond logo',
      hint: 'Vierkant logo als favicon en avatar. Optioneel — kan worden verwijderd.',
    },
    splash_image: {
      label: 'Inlogafbeelding',
      hint: 'Vult de linkerhelft van de white-label inlogpagina van rand tot rand (bijgesneden). Aanbevolen: staande opmaak, minimaal 1200×1200px. Optioneel — kan worden verwijderd.',
    },
    footer_note: 'Meer brandingopties (secundaire kleuren) volgen later.',
  },
  revenue_split: {
    title: 'Inkomstenverdeling',
    description:
      'Stel het aandeel van de partner in van elke vergoeding die FoodAmigos ontvangt op bestellingen van hun restaurants. Standaard 0% — FoodAmigos behoudt de volledige vergoeding totdat een aandeel wordt toegekend. Uitbetaald elke factuurcyclus.',
    manage_on_fees: 'Beheren op tabblad Tarieven',
    split: 'Partner {{partner}}% · FoodAmigos {{platform}}%',
    rows: {
      processing: 'Verwerkingskosten',
      gift_card: 'Cadeaukaarttarief',
      delivery: 'Bezorgkosten',
      service_fee: 'Servicekosten',
    },
    notes: {
      service_fee:
        'Het bedrag dat aan gasten in rekening wordt gebracht, wordt ingesteld onder Servicekosten-instellingen op het tabblad Kosten.',
    },
  },
  service_fee_controls: {
    title: 'Servicekostenbesturing',
    description: 'Wat de partner hun gasten als servicekosten bovenop de bestelling in rekening brengt.',
    zero_percentage_warning:
      'Een percentage van 0% schakelt de servicekosten niet uit: berekende kosten onder het minimumbedrag worden naar boven afgerond, zodat elke bestelling minimaal het minimum betaalt.',
  },
  hard_limits: {
    title: 'Harde limieten',
    description:
      'FoodAmigos-plafonds die worden afgedwongen bij opslaan en afrekenen. Geen servicekosten voor deze partner — inclusief per-restaurant overschrijvingen — mogen deze overschrijden.',
    max_percentage: {
      label: 'Maximale servicekosten %',
      help: 'De servicekosten van de partner kunnen hier niet boven worden ingesteld. Platformlimiet: 5%.',
    },
    min_amount: {
      label: 'Minimaal servicekostenbedrag',
      help: 'Minimumbedragen per restaurant kunnen niet onder dit bedrag worden ingesteld.',
    },
    max_amount: {
      label: 'Maximaal servicekostenbedrag',
      help: 'Absoluut maximum op de vaste servicekosten, ongeacht het percentage.',
    },
  },
  form: {
    charges_service_fee_on_site: {
      label: 'Servicekosten rekenen op tafelbestellingen',
      description:
        'De standaard voor de restaurants van deze partner; elk restaurant kan een eigen instelling kiezen. Uit: tafelbestellingen betalen geen servicekosten.',
    },
    is_service_fee_change_allowed: {
      label: 'Servicekosten per restaurant wijzigen toestaan',
      description: 'Laat de afzonderlijke restaurants van de partner andere servicekosten gebruiken.',
    },
    service_fee_platform_share: {
      label: 'Foodamigos-aandeel van de servicekosten',
    },
    recommended: 'Aanbevolen: {{value}}',
    service_fee_percentage: {
      label: 'Standaard servicekostenpercentage',
      help: 'Toegepast op elk restaurant van de partner, tenzij overschreven.',
    },
    min_service_fee_amount: {
      label: 'Standaard minimaal tarief',
      help: 'Standaard minimum per bestelling — berekende kosten hieronder worden afgerond. Restaurants kunnen hun eigen instelling bepalen binnen de FoodAmigos-limieten.',
    },
    max_service_fee_amount: {
      label: 'Standaard maximaal tarief',
      help: 'Standaard maximum per bestelling — restaurants kunnen hun eigen instelling bepalen binnen de FoodAmigos-limieten.',
    },
    primary_color: {
      label: 'Primaire merkkleur',
    },
    dashboard_subdomain: {
      label: 'Partner-inlogslug',
      hint: 'Kleine-lettersslug — identificeert het merk van de partner in de teamloginlink (?partner=…).',
      placeholder: 'partner-naam',
    },
    login_url: {
      label: 'Teamloginlink',
      hint: 'De link die het team van de partner gebruikt om de branded inlogpagina te bereiken.',
    },
    file: {
      label: 'Afbeelding',
    },
  },
  buttons: {
    edit: 'Bewerken',
    cancel: 'Annuleren',
    save: 'Opslaan',
  },
  toasts: {
    load_error: 'Instellingen konden niet worden geladen.',
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
    logo_uploaded: 'Logo geüpload',
    logo_upload_failed: 'Logo uploaden mislukt',
    logo_removed: 'Logo verwijderd',
    logo_remove_failed: 'Logo verwijderen mislukt',
    file_too_large: 'Bestand is te groot. Maximale grootte is {{max}} MB.',
    image_too_narrow: 'De inlogafbeelding moet minimaal {{min}}px breed zijn.',
  },
  notification_channels: {
    master_locked:
      'De hoofdpartner verzendt voor elk platformrestaurant, dus de kanalen kunnen hier niet worden gewijzigd.',
    unavailable: 'Meldingskanalen zijn nog niet beschikbaar op deze backend.',
    notice:
      'Interne instelling. Een partner zonder eigen Twilio-account moet alleen e-mail gebruiken: anders zouden alle sms-, WhatsApp-berichten en spraakoproepen via het FoodAmigos Twilio-account verlopen.',
    forbidden: 'Alleen super admins kunnen meldingskanalen wijzigen.',
    columns: {
      channel: 'Kanaal',
      status: 'Ingeschakeld',
    },
    channels: {
      email: {
        name: 'E-mail',
        description: 'Altijd actief, zodat de partner en zijn restaurants altijd bereikbaar zijn.',
      },
      sms: {
        name: 'Sms',
        description: 'Bestelupdates en inlogcodes naar gasten via sms.',
      },
      whatsapp: {
        name: 'WhatsApp',
        description: 'Meldingen aan restauranteigenaren en inlogcodes aan gasten via WhatsApp.',
      },
      voice_call: {
        name: 'Spraakoproepen',
        description: 'Herinneringsoproepen voor openstaande bestellingen en telefonische afhandeling.',
      },
      push: {
        name: 'Pushmeldingen',
        description:
          'Pushmeldingen naar gasten en naar de dashboard-app van de eigenaar. Meldingen op het personeelstablet worden niet beïnvloed.',
      },
    },
    toasts: {
      load_error: 'Kon de meldingskanalen niet laden.',
      error: 'Kon de meldingskanalen niet opslaan.',
      saved: 'Meldingskanalen opgeslagen.',
    },
  },
  feature_flags: {
    internal_notice:
      'Alleen-FoodAmigos-instellingen. Niet zichtbaar voor de partner. Wijzigingen worden direct van kracht.',
    read_only:
      'Alleen-lezen — het wijzigen van restaurantfacturering vereist een gecoördineerde uitrol, geen schakelaar. Neem contact op met engineering.',
    forbidden: 'Alleen superadmins kunnen partner-functiemarkeringen beheren.',
    columns: {
      feature: 'Functie',
      status: 'Status',
    },
    flags: {
      external_printer: {
        name: 'Externe bonprinter',
        description:
          'De standaardinstelling voor restaurants die deze partner vanaf nu aanmeldt: elk nieuw restaurant kan vanaf het begin een netwerkbonprinter koppelen aan de bestelterminal-app. Bestaande restaurants behouden de instelling van hun eigen tabblad Feature Flags, en elk restaurant kan daar nog steeds individueel worden aangepast.',
      },
      plg_onboarding: {
        name: 'Zelfbediening (PLG) onboarding',
        description:
          'Self-serve partneronboarding: geeft deze partner de begeleide pagina Nieuw restaurant en onboardingwizard in plaats van de klassieke modal Bedrijf toevoegen en de Aan de slag-stepper, verbergt FoodAmigos-only en nog niet toepasselijke onderdelen voor de partner en diens restaurants, en blokkeert de eerste live-gang totdat een startdatum is afgesproken. Standaard aan voor elke nieuwe partner.',
      },
      issue_end_customer_receipts: {
        name: 'Facturen voor eindklanten',
        description:
          'Laat gasten een factuur aanvragen bij het afrekenen en deze per e-mail ontvangen. Uit voor nieuwe partners; internationale factuurformaatregels maken het kostbaar om te ondersteunen.',
      },
      merchant_billing: {
        name: 'Restaurantfacturering',
        description:
          'Factureert de restaurants van de partner via het platform. Uit betekent dat ze buiten het platform afrekenen.',
      },
      cuisine_backfill: {
        name: 'Keuken-backfill',
        description: 'Staat de geautomatiseerde keukentype-backfill toe voor de restaurants van deze partner.',
      },
      image_backfill: {
        name: 'Afbeelding-backfill',
        description: 'Staat de geautomatiseerde menu-afbeelding-backfill toe voor de restaurants van deze partner.',
      },
      auto_image_generation: {
        name: 'Automatische afbeeldingsgeneratie',
        description: 'Genereert op aanvraag menu-afbeeldingen voor de restaurants van deze partner.',
      },
      provider_billing: {
        name: 'Partnerfacturering door Foodamigos',
        description:
          'Neemt deze partner op in de factuurronde van Foodamigos. Uit betekent dat de partner buiten het platform om wordt gefactureerd. Schakelt ook PayPal (direct) in voor de restaurants van deze partner, waarbij de servicekosten hierover worden geheven.',
      },
      partner_custom_dashboard_domain: {
        name: 'Eigen dashboarddomein',
        description:
          'Hiermee kan deze partner een eigen domein koppelen voor het dashboard, zodat het team en de restaurants inloggen via het adres van de partner. Aan- of uitzetten verplaatst elke dashboardlink die het platform voor deze partner verstuurt.',
      },
      partner_custom_shop_domain: {
        name: 'Eigen winkeldomein',
        description:
          'Laat deze partner een eigen domein koppelen voor de onlinewinkels van zijn restaurants, waarop elk restaurant een eigen adres krijgt. Per partner inschakelen: het wijzigt het adres dat klanten gebruiken.',
      },
      partner_legal_documents: {
        name: 'Juridische documenten partner',
        description:
          'Genereert het impressum, privacybeleid en de voorwaarden voor de restaurantshops van deze partner op basis van de juridische gegevens van elk restaurant. Uit, of zolang de gegevens van een restaurant onvolledig zijn, tonen shops de standaard platformdocumenten.',
      },
    },
    toasts: {
      load_error: 'Laden van functiemarkeringen mislukt',
      error: 'Wijzigen van de functiemarkering mislukt',
      enabled: 'Functie ingeschakeld',
      disabled: 'Functie uitgeschakeld',
    },
  },
};
